import { Button } from '@components'
import DocumentTagSelectorDropDown from '@root/containers/TagSelector/DocumentTagSelectorDropDown'
import { useTagSelectorFloating } from '@root/containers/TagSelector/useTagSelectorFloating'
import { useTags } from '@query'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { FaCaretDown, FaTag } from 'react-icons/fa'

type Props = {
  tagIds: number[]
  onTagIdsChange: (ids: number[]) => void
}

export const ReportTagFilter: React.FC<Props> = ({ tagIds, onTagIdsChange }) => {
  const [t] = useTranslation()
  const focusRef = useRef<HTMLButtonElement>(null)

  const {
    isDropDownOpen,
    toggleDropDown,
    handleOnSelect,
    context,
    refs,
    getReferenceProps,
    getFloatingProps
  } = useTagSelectorFloating({
    value: tagIds,
    onChange: onTagIdsChange,
    focusRef
  })

  const { data: selectedTags } = useTags({ tagIds })

  const soleSelectedName =
    tagIds.length === 1 ? selectedTags?.results?.find(tag => tag.id === tagIds[0])?.name : undefined

  const label =
    tagIds.length === 0
      ? t('reports.interactive.allTags')
      : soleSelectedName || t('reports.interactive.tagCount', { count: tagIds.length })

  return (
    <>
      <Button
        type="button"
        size="sm"
        icon={<FaTag style={tagIds.length > 0 ? { color: '#1b98f5' } : undefined} />}
        title={label}
        ref={node => {
          refs.setReference(node)
          focusRef.current = node
        }}
        {...getReferenceProps({
          onClick: () => toggleDropDown()
        })}
      >
        {label}
        <FaCaretDown style={{ fontSize: 9, color: '#a0aab5', marginLeft: 7 }} />
      </Button>

      {isDropDownOpen && (
        <DocumentTagSelectorDropDown
          context={context}
          getFloatingProps={getFloatingProps}
          refs={refs}
          onTagSelect={handleOnSelect}
          isSelected={tag => tagIds.includes(tag.id)}
          isOnlySelect
        />
      )}
    </>
  )
}
